import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-input-container"
}
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "form-input-box" }
const _hoisted_4 = { class: "form-input-text" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "validator-line"
}
const _hoisted_7 = {
  key: 1,
  class: "form-finish-container"
}
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "form-finish-title-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (!$setup.isFinish && !$setup.props.selectedContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString($setup.props.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.text) = $event)),
              class: _normalizeClass(['form-input', $setup.isH5 ? 'form-input-h5' : '']),
              placeholder: $setup.TUITranslateService.t('AIDesk.请输入内容')
            }, null, 10, _hoisted_5), [
              [_vModelText, $setup.text]
            ]),
            ($setup.validator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.TUITranslateService.t("AIDesk.请填写必填项")), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.submitForm())),
            class: "submit-icon"
          }, [
            _createVNode(_component_Icon, {
              src: $setup.iconSend,
              width: "30px",
              height: "30px"
            }, null, 8, ["src"])
          ])
        ])
      ]))
    : ($setup.isFinish || $setup.props.selectedContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString($setup.props.title), 1),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Icon, {
                src: $setup.iconSucess,
                style: {"margin":"0px 4px"}
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString($setup.TUITranslateService.t("AIDesk.已提交")), 1)
            ])
          ]),
          _createElementVNode("div", null, _toDisplayString($setup.props.selectedContent || $setup.text), 1)
        ]))
      : _createCommentVNode("", true)
}